<ion-app>
  <!-- Main layout with sidebar for authenticated non-auth routes -->
  @if (!isAuthRoute && isAuthenticated) {
    <ion-split-pane contentId="main-content" when="md">
      <ion-menu contentId="main-content" [disabled]="isMobile" [swipeGesture]="!isMobile">
      <ion-header>
        <ion-toolbar>
          <ion-title (click)="navigateTo('/')" style="cursor: pointer;">
            <div class="logo-container">
              <ion-img src="assets/Barter_Bridge_logo_registered.svg" alt="Barter Bridge" class="w-32 h-32"></ion-img>
            </div>
          </ion-title>
        </ion-toolbar>
      </ion-header>
      <ion-content>
        <ion-list>
          @for (p of commonPages; track p.title) {
            <ion-menu-toggle [autoHide]="false">
              <ion-item [button]="true" [routerLink]="p.url" routerLinkActive="active-item" [routerLinkActiveOptions]="{exact: p.url === '/'}">
                <ion-icon slot="start" [name]="p.icon"></ion-icon>
                <ion-label>{{ p.title }}</ion-label>
              </ion-item>
            </ion-menu-toggle>
          }
        </ion-list>

      </ion-content>
    </ion-menu>

    <ion-tabs id="main-content">
      <ion-header class="ion-no-border app-header-bar">
        <app-header></app-header>
      </ion-header>

      <ion-router-outlet></ion-router-outlet>

        <ion-tab-bar slot="bottom" class="mobile-only-tab-bar">
          <ion-tab-button tab="home" href="/home" (click)="resetTabToRoot('/home')">
            <ion-icon name="home-outline"></ion-icon>
            <ion-label>Home</ion-label>
          </ion-tab-button>

          <ion-tab-button tab="explore" href="/explore" (click)="resetTabToRoot('/explore')">
            <ion-icon name="search-outline"></ion-icon>
            <ion-label>Explore</ion-label>
          </ion-tab-button>

          <ion-tab-button tab="trades" href="/trades" (click)="resetTabToRoot('/trades')">
            <ion-icon name="swap-horizontal-outline"></ion-icon>
            <ion-label>Trades</ion-label>
          </ion-tab-button>

          <ion-tab-button tab="business" href="/business" (click)="resetTabToRoot('/business')">
            <ion-icon name="briefcase-outline"></ion-icon>
            <ion-label>Business</ion-label>
          </ion-tab-button>

          <ion-tab-button tab="account" href="/account" (click)="resetTabToRoot('/account')">
            <ion-icon name="person-outline"></ion-icon>
            <ion-label>Account</ion-label>
          </ion-tab-button>
        </ion-tab-bar>
    </ion-tabs>
    </ion-split-pane>
  }

  <!-- Auth layout without sidebar -->
  @if (isAuthRoute || !isAuthenticated) {
    <div class="auth-layout">
      <ion-router-outlet></ion-router-outlet>
    </div>
  }
</ion-app>
